export const adminRoutes = [];
